class CreateRequestPathAIResult {
    Accepted: boolean;
    Url: string;
    Token: string;

    constructor(accepted: boolean, url: string, token: string) {
        this.Accepted = accepted;
        this.Url = url;
        this.Token = token;
    }
}

export default CreateRequestPathAIResult;
